<span [hidden]="!loading"> <ab-spinner-inline></ab-spinner-inline></span>
<div class="integration-error" *ngIf="error">
  <b>{{ error.error }}:&nbsp;</b>{{ error.errorMessage }}<br /><a
    href="/projects/{{ notice.projectId }}/services/4"
    target="_self"
    >Check your settings</a
  >
</div>
<button
  class="btn btn-holder"
  *ngIf="!story?.url && !error && !loading"
  (click)="createStory()"
  [disabled]="creatingStory"
  type="button"
>
  <span *ngIf="!creatingStory"
    ><i
      class="glyphicon glyphicon-ab-integrations-pivotal glyphicon--valign-baseline"
    ></i
    >&nbsp; Create Pivotal Tracker story</span
  ><span [hidden]="!creatingStory">
    <ab-spinner-inline></ab-spinner-inline>Create Pivotal Tracker story</span
  >
</button>
<div *ngIf="story?.url">
  <i
    class="glyphicon glyphicon-ab-integrations-pivotal glyphicon--valign-baseline"
  ></i
  >&nbsp;<ab-external-link *ngIf="story.url" href="{{ story.url }}"
    >View on Pivotal Tracker</ab-external-link
  >&nbsp;
  <button
    class="btn btn-holder btn--reduced-padding"
    *ngIf="story.url && !error"
    (click)="removeStory()"
    [disabled]="removingStory"
    type="button"
  >
    <span *ngIf="!removingStory">Remove</span
    ><span [hidden]="!removingStory">
      <ab-spinner-inline></ab-spinner-inline>Removing</span
    >
  </button>
</div>
